/**
 * Dummy data — 가격 조회 (서비스) + 관리자 가격 관리
 * API_DOCS: 6. 가격 조회 / 20. 관리자 - 가격
 *
 * 서비스:
 *   POST /api/price/search → PricingSearchResponse
 *   GET  /api/price/options → OptionPriceResponse[]
 *   GET  /api/price/surcharges → SurchargeResponse[]
 *
 * 관리자:
 *   GET/PUT  /api/admin/price/airport
 *   GET/POST/PUT/DELETE /api/admin/price/golf
 *   GET/PUT  /api/admin/price/golf-regional
 *   GET/PUT  /api/admin/price/options
 */

// BugHerd #68/#69: '서울' / '경기 북부' / '경기 남부' 등 광역 단위 row 는 #34 작업으로
// 구·시·군 단위로 세분화되며 폐기됨. dummy 도 BE seed_data 와 동일 구조로 정렬.
const airportPricing = [
  { id: 1, name: '강남구', parent_region: '서울', region_type: 'district', incheon_price: 139000, gimpo_price: 109000 },
  { id: 2, name: '노원구', parent_region: '서울', region_type: 'district', incheon_price: 149000, gimpo_price: 119000 },
  { id: 3, name: '고양시', parent_region: '경기', region_type: 'city',     incheon_price: 139000, gimpo_price: 129000 },
  { id: 4, name: '중구',   parent_region: '인천', region_type: 'district', incheon_price: 129000, gimpo_price: 139000 },
];

const golfPricing = [
  { id: 1, golf_id: 1, departure_city: '서울', is_weekend: false, price: 250000, is_active: true },
  { id: 2, golf_id: 1, departure_city: '서울', is_weekend: true, price: 300000, is_active: true },
  { id: 3, golf_id: 2, departure_city: '서울', is_weekend: false, price: 280000, is_active: true },
];

const golfRegionalPricing = [
  { id: 1, name: '경기', price: 250000 },
  { id: 2, name: '강원', price: 350000 },
  { id: 3, name: '인천', price: 280000 },
];

const options = [
  // applicable_services: 'airport,golf' 콤마 구분, NULL=전체 적용
  // #10: 카시트는 영아용(0~4세, max 1) + 주니어용(3~12세, max 2) 2종 — 기존 child_seat 비활성화
  { id: 1, code: 'child_seat',     name: '카시트 추가',     price: 9900,  pricing_tiers: null, applicable_services: 'airport,golf,ski,hospital,pet,business', is_active: false, max_qty: 3, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 2, code: 'extra_luggage',  name: '추가 수하물',     price: 9900,  pricing_tiers: null, applicable_services: 'airport,ski,hospital,pet,business',     is_active: true,  max_qty: 0, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 3, code: 'wheelchair',     name: '휠체어 적재',     price: 9900,  pricing_tiers: null, applicable_services: 'hospital',                              is_active: true,  max_qty: 1, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 4, code: 'meeting',        name: '공항 피켓 서비스',price: 19900, pricing_tiers: null, applicable_services: 'airport',                               is_active: true,  max_qty: 1, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 5, code: 'suit',           name: '정장 서비스',     price: 29900, pricing_tiers: null, applicable_services: 'airport,golf,hospital,business',       is_active: true,  max_qty: 1, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 6, code: 'english',        name: '영어 가능 기사',  price: 19900, pricing_tiers: null, applicable_services: null,                                    is_active: true,  max_qty: 1, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 7, code: 'golfbag',        name: '골프백+보스턴백 추가', price: 9900, pricing_tiers: null, applicable_services: 'golf',                                  is_active: true,  max_qty: 6, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 8, code: 'ski_equip',      name: '스키 장비 추가',  price: 9900,  pricing_tiers: null, applicable_services: 'ski',                                   is_active: true,  max_qty: 6, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 9, code: 'companion',      name: '동행 서비스',     price: 49900, pricing_tiers: null, applicable_services: 'hospital',                              is_active: true,  max_qty: 1, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 10, code: 'infant_carseat',name: '영아용 카시트',   price: 9900,  pricing_tiers: null, applicable_services: 'airport,hospital,pet,business',         is_active: true,  max_qty: 1, created_at: '2026-04-28T00:00:00+09:00', updated_at: null },
  { id: 11, code: 'junior_carseat',name: '주니어용 카시트', price: 9900,  pricing_tiers: null, applicable_services: 'airport,hospital,pet,business',         is_active: true,  max_qty: 2, created_at: '2026-04-28T00:00:00+09:00', updated_at: null },
];

const surcharges = [
  { type: 'weekend', description: '주말/공휴일 할증', amount: 20000 },
  { type: 'night', description: '야간 할증 (22:00~06:00)', amount: 20000 },
  { type: 'holiday', description: '명절 할증', amount: 50000 },
  { type: 'roundtrip', description: '왕복 선택시 추가 요금', amount: 100000 },
  { type: 'stopover', description: '경유지 추가 요금', amount: 30000 },
];

/* ── 서비스별 선택 옵션 (어드민에서 추가/삭제 가능) ── */
/* BugHerd #33: extraLabel에서 가격 단가 제거. 어드민이 가격을 변경하면 라벨까지 따라 변경되어야 하는 결합을 끊고
 *              "N 초과 시 추가 요금 발생" 정적 문구로 통일. */
const serviceOptions = {
  airport: [
    { id: 'people', name: '이용 인원', price: 0, min: 1, defaultQty: 4, baseQty: 4, unit: '명', variant: 'number', extraLabel: '4인 초과 시 추가 요금 발생' },
    { id: 'luggage', name: '수하물', price: 9900, min: 0, defaultQty: 4, baseQty: 4, unit: '개', variant: 'number', extraLabel: '4개 초과 시 추가 요금 발생' },
    { id: 'infant_carseat', name: '영아용 카시트', price: 9900, min: 0, max: 1, defaultQty: 0, unit: '개', variant: 'number', extraLabel: '0~4세, Max 105cm/18kg' },
    { id: 'junior_carseat', name: '주니어용 카시트', price: 9900, min: 0, max: 2, defaultQty: 0, unit: '개', variant: 'number', extraLabel: '3~12세, Max 150cm/50kg' },
    { id: 'meeting', name: '공항 피켓 서비스', price: 19900, variant: 'checkbox' },
    { id: 'suit', name: '정장 서비스', price: 29900, variant: 'checkbox' },
    { id: 'english', name: '영어 가능 기사', price: 19900, variant: 'checkbox' },
  ],
  golf: [
    { id: 'golfbag', name: '골프백+보스턴백 추가', price: 9900, min: 0, defaultQty: 4, baseQty: 4, unit: '세트', variant: 'number', extraLabel: '4세트 초과 시 추가 요금 발생 (골프백+보스턴백 1세트 = 캐리어 1개)' },
    { id: 'people', name: '이용 인원', price: 9900, min: 1, defaultQty: 4, baseQty: 4, unit: '명', variant: 'number', extraLabel: '4인 초과 시 추가 요금 발생' },
    { id: 'suit', name: '정장 서비스', price: 19900, variant: 'checkbox' },
    { id: 'english', name: '영어 가능 기사', price: 29900, variant: 'checkbox' },
  ],
  ski: [
    { id: 'people', name: '이용 인원', price: 0, min: 1, defaultQty: 4, baseQty: 4, unit: '명', variant: 'number', extraLabel: '4인 초과 시 추가 요금 발생' },
    { id: 'luggage', name: '수하물', price: 9900, min: 0, defaultQty: 4, baseQty: 4, unit: '개', variant: 'number', extraLabel: '4개 초과 시 추가 요금 발생' },
    { id: 'ski_equip', name: '스키 장비 추가', price: 9900, min: 0, max: 6, defaultQty: 0, unit: '개', variant: 'number', extraLabel: '4세트 초과 시 추가 요금 발생' },
    { id: 'english', name: '영어 가능 기사', price: 19900, variant: 'checkbox' },
  ],
  hospital: [
    { id: 'people', name: '이용 인원', price: 9900, min: 1, defaultQty: 4, baseQty: 4, unit: '명', variant: 'number', extraLabel: '4인 초과 시 추가 요금 발생' },
    { id: 'wheelchair', name: '휠체어 적재', price: 9900, variant: 'checkbox', extraLabel: '로프트 없음, 적재만 가능' },
    { id: 'companion', name: '동행서비스', price: 49900, variant: 'checkbox', extraLabel: '병원 입/퇴원 수속 지원 및 운반 적재' },
    { id: 'luggage', name: '수화물 추가', price: 9900, min: 0, defaultQty: 4, baseQty: 4, unit: '개', variant: 'number', extraLabel: '4개 초과 시 추가 요금 발생' },
    { id: 'infant_carseat', name: '영아용 카시트', price: 9900, min: 0, max: 1, defaultQty: 0, unit: '개', variant: 'number', extraLabel: '0~4세, Max 105cm/18kg' },
    { id: 'junior_carseat', name: '주니어용 카시트', price: 9900, min: 0, max: 2, defaultQty: 0, unit: '개', variant: 'number', extraLabel: '3~12세, Max 150cm/50kg' },
    { id: 'suit', name: '정장 서비스', price: 19900, variant: 'checkbox' },
    { id: 'english', name: '영어 가능 기사', price: 29900, variant: 'checkbox' },
    { id: 'night', name: '야간 할증', price: 10000, variant: 'checkbox', auto: true },
  ],
  pet: [
    { id: 'people', name: '이용 인원', price: 0, min: 1, defaultQty: 4, baseQty: 4, unit: '명', variant: 'number', extraLabel: '4인 초과 시 추가 요금 발생' },
    { id: 'luggage', name: '수하물', price: 9900, min: 0, defaultQty: 4, baseQty: 4, unit: '개', variant: 'number', extraLabel: '4개 초과 시 추가 요금 발생' },
    { id: 'infant_carseat', name: '영아용 카시트', price: 9900, min: 0, max: 1, defaultQty: 0, unit: '개', variant: 'number', extraLabel: '0~4세, Max 105cm/18kg' },
    { id: 'junior_carseat', name: '주니어용 카시트', price: 9900, min: 0, max: 2, defaultQty: 0, unit: '개', variant: 'number', extraLabel: '3~12세, Max 150cm/50kg' },
    { id: 'english', name: '영어 가능 기사', price: 19900, variant: 'checkbox' },
  ],
  business: [
    { id: 'people', name: '이용 인원', price: 0, min: 1, defaultQty: 4, baseQty: 4, unit: '명', variant: 'number', extraLabel: '4인 초과 시 추가 요금 발생' },
    { id: 'luggage', name: '수하물', price: 9900, min: 0, defaultQty: 4, baseQty: 4, unit: '개', variant: 'number', extraLabel: '4개 초과 시 추가 요금 발생' },
    { id: 'infant_carseat', name: '영아용 카시트', price: 9900, min: 0, max: 1, defaultQty: 0, unit: '개', variant: 'number', extraLabel: '0~4세, Max 105cm/18kg' },
    { id: 'junior_carseat', name: '주니어용 카시트', price: 9900, min: 0, max: 2, defaultQty: 0, unit: '개', variant: 'number', extraLabel: '3~12세, Max 150cm/50kg' },
    { id: 'suit', name: '정장 서비스', price: 29900, variant: 'checkbox' },
    { id: 'english', name: '영어 가능 기사', price: 19900, variant: 'checkbox' },
  ],
};

/* ── 서비스별 할증/현장추가요금 ── */
const serviceSurcharges = {
  airport: { surchargeTitle: '현장 추가 요금 안내', overtime: '시간 초과 요금: 19,900원 / 1시간 당', overtime_price: 19900, stopover_price: 29900 },
  golf:    { surchargeTitle: '현장 추가 요금 안내', overtime: '시간 초과 요금: 49,900원 / 1시간 당', overtime_price: 49900, stopover_price: 0, weekend: '주말·공휴일 (+20,000원)' },
  ski:     { surchargeTitle: '현장 추가 요금 안내', overtime: '시간 초과 요금: 39,900원 / 1시간 당', overtime_price: 39900, stopover_price: 0, weekend: '주말·공휴일 (+20,000원)' },
  hospital:{ surchargeTitle: '현장 추가 요금 안내', overtime: '시간 초과 요금: 49,900원 / 1시간 당', overtime_price: 49900, stopover_price: 0 },
  pet:     { surchargeTitle: '현장 추가 요금 안내', overtime: '시간 초과 요금: 39,900원 / 1시간 당', overtime_price: 39900, stopover_price: 0 },
  business:{ surchargeTitle: '현장 추가 요금 안내', overtime: '시간 초과 요금: 39,900원 / 1시간 당', overtime_price: 39900, stopover_price: 0 },
};

/* ── 예약 폼 필드 설정 (어드민 수정 가능) ── */
const bookingFormConfig = {
  bookerFields: [
    { id: 'userName', label: '이용자명', placeholder: '이름을 입력해주세요', type: 'text' },
    { id: 'phone', label: '연락처', placeholder: '', type: 'phone' },
    { id: 'email', label: '이메일', placeholder: 'example@email.com', type: 'text' },
  ],
  bookerNotice: '*연락처가 한국 외로 선택된 경우, 이메일로 알림이 전송됩니다.',
  arrivalLabels: {
    airport: '도착지(공항)',
    golf: '도착지(골프장)',
    ski: '도착지(리조트)',
    hospital: '도착지(병원)',
    pet: '도착지',
    business: '도착지',
  },
};

/* ── 차량 정보 ── */
const vehicleInfo = {
  common: { carName: '2026년 신형 스타리아 라운지 블랙', seat: '2열 프리미엄 릴렉션 시트', capacity: '탑승 인원: 4인(기본) ~ 6인(최대)', luggage: '적정 수화물: 28인치 이하 캐리어 4개(기본)', reviewTitle: '프라이빗 이동 후기', reviewRating: '4.8', priceNote: '*요금은 차량, 운전기사, 유류비, 톨게이트 비용 포함' },
  perType: {
    airport: { luggage: '적정 수화물: 28인치 이하 캐리어 4개(기본)', usageTimeBadge: null, basePrice: 139000, waitInfo: { overtimePrice: 19900, overtimeI18nKey: 'booking.overtime_waiting_fee_per_hour' } },
    golf:    { luggage: '적정 수화물: 골프백+보스턴백 4세트(기본)', usageTimeBadge: '기본 이용시간 9시간', basePrice: 139000, waitInfo: { overtimePrice: 39900, overtimeI18nKey: 'booking.overtime_fee_per_hour' } },
    ski:     { luggage: '적정 수화물: 28인치 이하 캐리어 4개(기본)', usageTimeBadge: '기본 이용시간 9시간', basePrice: 139000, waitInfo: { overtimePrice: 39900, overtimeI18nKey: 'booking.overtime_fee_per_hour' } },
    hospital:{ luggage: '적정 수화물: 28인치 이하 캐리어 4개(기본)', usageTimeBadge: '기본 이용시간 2시간', basePrice: 139000, waitInfo: { overtimePrice: 39900, overtimeI18nKey: 'booking.overtime_fee_per_hour' } },
    pet:     { luggage: '적정 수화물: 케이지', usageTimeBadge: '기본 이용시간 2시간', basePrice: 139000, waitInfo: { overtimePrice: 39900, overtimeI18nKey: 'booking.overtime_fee_per_hour' } },
    business:{ luggage: '적정 수화물: 28인치 이하 캐리어 4개(기본)', usageTimeBadge: '기본 이용시간 2시간', basePrice: 139000, waitInfo: { overtimePrice: 39900, overtimeI18nKey: 'booking.overtime_fee_per_hour' } },
  },
};

/* ── 랜딩 페이지 콘텐츠 (어드민 관리 가능) ── */
const landingGallery = [
  { id: 1, image_url: '/images/banner/Banner01.png', alt: '배너 1', link_url: 'signup-coupon:VIPWELCOME' },
  { id: 2, image_url: '/images/banner/Banner02.png', alt: '배너 2' },
  { id: 3, image_url: '/images/banner/Banner03.png', alt: '배너 3' },
  { id: 4, image_url: '/images/banner/Banner04.png', alt: '배너 4' },
  { id: 5, image_url: '/images/banner/Banner05.png', alt: '배너 5' },
  { id: 6, image_url: '/images/banner/Banner06.png', alt: '배너 6' },
];

const landingVehicleSlides = [
  { id: 1, tag: 'PREMIUM SEAT', title: '2026년 최신형 독립 릴렉션 시트', desc: '스타리아 라운지 2열 최고급 독립 시트로\n이동 시간도 편안한 휴식이 됩니다', image_url: null },
  { id: 2, tag: 'SPACIOUS TRUNK', title: '넉넉한 트렁크 공간', desc: '캐리어 4개 이상 수납 가능한 넓은 트렁크로\n공항 이동이 편리합니다', image_url: null },
];

const landingServiceFeatures = [
  { id: 1, icon: 'garage-check', title: '법인 직접 운영', desc: '중개 업체가 아닌,\n법인이 직접 차량을 관리하고 책임 운영합니다' },
  { id: 2, icon: 'license', title: '정식 허가 업체', desc: '종합여행업 등록 및 콜밴 영업 허가를\n정식으로 취득한 업체입니다' },
  { id: 3, icon: 'person-shield', title: '7년 무사고 운행', desc: '무사고, 무벌점, 범죄 이력 없는\n검증된 기사가 운행합니다' },
  { id: 4, icon: 'id-card', title: '전문 자격 보유', desc: '관광통역안내사, 택시운전, 화물운송 자격증을\n보유하고 있습니다' },
];

/* ── 요일별 할증 (어드민) ── */
const weekdaySurcharges = [
  { day: '월', price: '0', color: 'text-mono-900' },
  { day: '화', price: '0', color: 'text-mono-900' },
  { day: '수', price: '0', color: 'text-mono-900' },
  { day: '목', price: '0', color: 'text-mono-900' },
  { day: '금', price: '0', color: 'text-mono-900' },
  { day: '토', price: '10,000', color: 'text-blue-500' },
  { day: '일', price: '10,000', color: 'text-red-500' },
];

/* ── 쿠폰 (프로모 코드) ── */
const coupons = [
  { id: 1, code: 'VIPWELCOME', name: '첫 가입 환영',  coupon_type: 'new',     discount_type: 'fixed',      discount_value: 14900, is_active: true, expiry_date: null,         max_uses: null, per_user_limit: 1,   usage_count: 12, applicable_services: null,   description: '첫 결제 고객 한정 14,900원 할인', created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 2, code: 'GOLFMASTER', name: '골프 투어 홍보', coupon_type: 'regular', discount_type: 'fixed',      discount_value: 20000, is_active: true, expiry_date: '2026-12-31', max_uses: 100,  per_user_limit: 999, usage_count: 5,  applicable_services: 'golf', description: '골프 상품 예약 시 20,000원 할인 (반복 사용 가능)', created_at: '2026-01-15T00:00:00+09:00', updated_at: null },
  { id: 3, code: 'HOTEL_SEOUL', name: '호텔 제휴',    coupon_type: 'regular', discount_type: 'percentage', discount_value: 10,    is_active: true, expiry_date: '2026-06-30', max_uses: 50,   per_user_limit: 3,   usage_count: 3,  applicable_services: null,   description: '제휴 호텔 유입 고객 10% 할인 (1인 3회)', created_at: '2026-02-01T00:00:00+09:00', updated_at: null },
];

/* ── 약관 (결제 시 동의 항목) ──
 * BugHerd #131: 라벨에 [필수]/[선택] 텍스트 prefix 폐기 — required 플래그만 유지.
 * 렌더링은 CheckBox 의 required/optional prop 으로 별표/(선택) 인라인 노출. */
const paymentTerms = [
  { id: 1, label: '개인정보 수집 및 이용 동의', required: true, url: '/terms/privacy' },
  { id: 2, label: '마케팅 정보 수신 동의', required: false, url: '/terms/marketing' },
];

/* ── 환불 규정 ── */
const refundPolicy = [
  { label: '이용일 3일 전', value: '100% 환불' },
  { label: '이용일 2일 전', value: '80% 환불' },
  { label: '이용일 1일 전', value: '50% 환불' },
  { label: '당일 취소', value: '환불 불가' },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ── 서비스 (유저용) ── */

/** POST /api/price/search */
export const searchPrice = async (data) => {
  await delay(300);
  return {
    base_price: 198000,
    surcharges: data.date && new Date(data.date).getDay() === 0 ? [surcharges[0]] : [],
    options: options.filter((o) => o.is_active),
    total: 198000,
  };
};

/** GET /api/price/options */
export const getOptions = async () => {
  await delay(200);
  return options.filter((o) => o.is_active);
};

/** GET /api/price/surcharges */
export const getSurcharges = async () => {
  await delay(200);
  return surcharges;
};

/** GET /api/price/config/{serviceType} (full config) */
export const getServiceConfig = async (serviceType) => {
  await delay(150);
  // dummy: 기본값 반환 — 실제 운영은 BE 응답 사용
  const defaults = {
    airport: { base_hours: null, overtime_price: 19900, free_wait_minutes: 60 },
    golf: { base_hours: 9, overtime_price: 39900, free_wait_minutes: null },
    ski: { base_hours: 9, overtime_price: 49900, free_wait_minutes: null },
    hospital: { base_hours: 2, overtime_price: 49900, free_wait_minutes: null },
    pet: { base_hours: 2, overtime_price: 49900, free_wait_minutes: null },
    business: { base_hours: 2, overtime_price: 49900, free_wait_minutes: null },
    tour: { base_hours: 2, overtime_price: 39900, free_wait_minutes: null },
  };
  return defaults[serviceType] || defaults.airport;
};

/** GET /api/price/service-options?service_type=airport */
export const getServiceOptions = async (serviceType) => {
  await delay(200);
  return serviceOptions[serviceType] || serviceOptions.airport;
};

/** GET /api/price/service-surcharges?service_type=airport */
export const getServiceSurcharges = async (serviceType) => {
  await delay(150);
  return serviceSurcharges[serviceType] || serviceSurcharges.airport;
};

/** GET /api/price/regional?service_type=golf */
export const getRegionalPricing = async (serviceType) => {
  await delay(200);
  const pricing = {
    golf: [
      { region: 'gyeonggi', label: '경기', price: 399000 },
      { region: 'incheon', label: '인천', price: 369000 },
      { region: 'gangwon', label: '강원', price: 469000 },
    ],
    ski: [
      { region: 'gyeonggi', label: '경기', price: 399000 },
      { region: 'gangwon', label: '강원', price: 449000 },
    ],
    hospital: [
      { region: '서울', label: '서울', price: 99900 },
      { region: '분당', label: '분당', price: 149900 },
    ],
  };
  return pricing[serviceType] || [];
};

/** GET /api/price/weekday-surcharges */
/** GET /api/price/booking-form-config */
export const getBookingFormConfig = async () => {
  await delay(150);
  return bookingFormConfig;
};

export const getWeekdaySurcharges = async () => {
  await delay(200);
  return weekdaySurcharges;
};

/** GET /api/vehicle/info?service_type=airport */
export const getVehicleInfo = async (serviceType) => {
  await delay(150);
  return {
    ...vehicleInfo.common,
    ...(vehicleInfo.perType[serviceType] || vehicleInfo.perType.airport),
  };
};

/** GET /api/landing/gallery — 랜딩 갤러리 이미지 */
export const getLandingGallery = async () => {
  await delay(100);
  return landingGallery;
};

/** GET /api/landing/vehicle-slides — 랜딩 차량 슬라이드 */
export const getLandingVehicleSlides = async () => {
  await delay(100);
  return landingVehicleSlides;
};

/** GET /api/landing/service-features — 랜딩 서비스 특징 */
export const getLandingServiceFeatures = async () => {
  await delay(100);
  return landingServiceFeatures;
};

/** GET /api/price/refund-policy */
export const getRefundPolicy = async () => {
  await delay(100);
  return refundPolicy;
};

/** POST /api/coupons/validate — 할인 코드 검증 */
export const validateCoupon = async (code) => {
  await delay(200);
  const upper = (code || '').trim().toUpperCase();
  const coupon = coupons.find((c) => c.code === upper && c.is_active);
  if (!coupon) return { valid: false, message: '유효하지 않은 할인 코드입니다.' };
  if (coupon.expiry_date && new Date(coupon.expiry_date) < new Date()) return { valid: false, message: '만료된 할인 코드입니다.' };
  if (coupon.max_uses !== null && coupon.usage_count >= coupon.max_uses) return { valid: false, message: '사용 횟수가 초과된 할인 코드입니다.' };
  return { valid: true, name: coupon.name, discount_type: coupon.discount_type, discount_value: coupon.discount_value };
};

/** @deprecated validateCoupon으로 대체 */
export const getCoupons = async () => [];

/** @deprecated validateCoupon으로 대체 */
export const applyCoupon = async () => null;

/* ── 관리자 - 쿠폰 ── */

/** GET /api/admin/coupons */
export const getAdminCoupons = async (params) => {
  await delay(200);
  if (params?.is_active !== undefined) return coupons.filter((c) => c.is_active === params.is_active);
  return [...coupons];
};

/** POST /api/admin/coupons */
export const createAdminCoupon = async (data) => {
  await delay(300);
  const newCoupon = { id: coupons.length + 1, ...data, code: (data.code || '').toUpperCase(), usage_count: 0, created_at: new Date().toISOString(), updated_at: null };
  coupons.push(newCoupon);
  return newCoupon;
};

/** GET /api/admin/coupons/:id */
export const getAdminCoupon = async (id) => {
  await delay(200);
  const coupon = coupons.find((c) => c.id === Number(id));
  if (!coupon) throw new Error('쿠폰을 찾을 수 없습니다.');
  return coupon;
};

/** PUT /api/admin/coupons/:id */
export const updateAdminCoupon = async (id, data) => {
  await delay(300);
  const idx = coupons.findIndex((c) => c.id === Number(id));
  if (idx === -1) throw new Error('쿠폰을 찾을 수 없습니다.');
  Object.assign(coupons[idx], data, { updated_at: new Date().toISOString() });
  if (data.code) coupons[idx].code = data.code.toUpperCase();
  return coupons[idx];
};

/** DELETE /api/admin/coupons/:id */
export const deleteAdminCoupon = async (id) => {
  await delay(200);
  const idx = coupons.findIndex((c) => c.id === Number(id));
  if (idx === -1) throw new Error('쿠폰을 찾을 수 없습니다.');
  coupons[idx].is_active = false;
  return { message: '쿠폰이 삭제되었습니다.' };
};

/** GET /api/admin/coupons/:id/usages */
export const getAdminCouponUsages = async () => {
  await delay(200);
  return [
    { id: 1, coupon_id: 1, user_id: 101, reservation_id: 501, used_at: '2026-03-01T10:30:00+09:00' },
    { id: 2, coupon_id: 1, user_id: 102, reservation_id: 502, used_at: '2026-03-05T14:20:00+09:00' },
  ];
};

/** GET /api/payment/terms — 결제 약관 목록 */
export const getPaymentTerms = async () => {
  await delay(100);
  return paymentTerms;
};

/* ── 관리자 ── */

/** GET /api/admin/price/airport */
export const getAdminAirportPricing = async () => {
  await delay(300);
  return airportPricing;
};

/** PUT /api/admin/price/airport/:regionId */
export const updateAdminAirportPricing = async (regionId, data) => {
  await delay(400);
  const found = airportPricing.find((p) => p.id === Number(regionId));
  if (!found) throw new Error('지역을 찾을 수 없습니다');
  Object.assign(found, data);
  return found;
};

/** GET /api/admin/price/golf */
export const getAdminGolfPricing = async () => {
  await delay(300);
  return golfPricing;
};

/** POST /api/admin/price/golf */
export const createAdminGolfPricing = async (data) => {
  await delay(400);
  const newPricing = { id: golfPricing.length + 1, ...data, is_active: true };
  golfPricing.push(newPricing);
  return newPricing;
};

/** PUT /api/admin/price/golf/:pricingId */
export const updateAdminGolfPricing = async (pricingId, data) => {
  await delay(400);
  const idx = golfPricing.findIndex((p) => p.id === Number(pricingId));
  if (idx === -1) throw new Error('가격을 찾을 수 없습니다');
  golfPricing[idx] = { ...golfPricing[idx], ...data };
  return golfPricing[idx];
};

/** DELETE /api/admin/price/golf/:pricingId */
export const deleteAdminGolfPricing = async (pricingId) => {
  await delay(300);
  const idx = golfPricing.findIndex((p) => p.id === Number(pricingId));
  if (idx === -1) throw new Error('가격을 찾을 수 없습니다');
  golfPricing.splice(idx, 1);
  return { message: '가격이 삭제되었습니다' };
};

/** GET /api/admin/price/golf-regional */
export const getAdminGolfRegionalPricing = async () => {
  await delay(300);
  return golfRegionalPricing;
};

/** PUT /api/admin/price/golf-regional/:pricingId */
export const updateAdminGolfRegionalPricing = async (pricingId, data) => {
  await delay(400);
  const idx = golfRegionalPricing.findIndex((p) => p.id === Number(pricingId));
  if (idx === -1) throw new Error('가격을 찾을 수 없습니다');
  golfRegionalPricing[idx] = { ...golfRegionalPricing[idx], ...data };
  return golfRegionalPricing[idx];
};

/** GET /api/admin/price/options?service_type=xxx
 *  service_type 전달 시 해당 서비스 적용 옵션 + 전체적용(null) 옵션만 필터.
 */
export const getAdminOptions = async (params) => {
  await delay(200);
  const svc = params?.service_type;
  if (!svc) return [...options];
  return options.filter((o) => {
    const svcs = (o.applicable_services || '').trim();
    if (!svcs) return true;
    return svcs.split(',').map((s) => s.trim()).includes(svc);
  });
};

/** POST /api/admin/price/options */
export const createAdminOption = async (data) => {
  await delay(300);
  // 코드는 시스템 내부 키. 미지정시 자동 생성.
  const code = ((data.code || '').trim()) || `opt_${Date.now()}`;
  if (options.some((o) => o.code === code)) throw new Error('이미 존재하는 옵션 코드입니다.');
  const newOption = {
    id: Math.max(0, ...options.map((o) => o.id)) + 1,
    code,
    name: data.name || '',
    price: Number(data.price) || 0,
    pricing_tiers: data.pricing_tiers || null,
    applicable_services: data.applicable_services || null,
    max_qty: Number(data.max_qty) || 0,
    is_active: data.is_active !== false,
    created_at: new Date().toISOString(),
    updated_at: null,
  };
  options.push(newOption);
  return newOption;
};

/** DELETE /api/admin/price/options/:optionId */
export const deleteAdminOption = async (optionId) => {
  await delay(200);
  const idx = options.findIndex((o) => o.id === Number(optionId));
  if (idx === -1) throw new Error('옵션을 찾을 수 없습니다.');
  options.splice(idx, 1);
  return { message: '옵션이 삭제되었습니다.' };
};

/** GET /api/admin/price/conditional-surcharges — 조건별 추가 요금 */
const conditionalSurcharges = {
  roundTrip: { label: '왕복 적용', price: '20,000' },
  stopover: { label: '경유지 1건당', price: '29,900' },
  timeSlots: [
    { id: 1, startTime: '00:00', endTime: '06:00', price: '10,000' },
    { id: 2, startTime: '18:00', endTime: '23:59', price: '10,000' },
  ],
  holiday: { label: '공휴일 적용', price: '10,000' },
};

export const adminGetConditionalSurcharges = async () => {
  await delay(200);
  return conditionalSurcharges;
};

/** GET /api/admin/price/onsite-surcharges — 현장 추가 요금 */
const onsiteSurcharges = {
  waitOvertime: {
    pickup: { freeMinutes: 90, overtimePrice: '10,000' },
    sending: { freeMinutes: 90, overtimePrice: '10,000' },
  },
  driveOvertime: { baseMinutes: 120, overtimePrice: '19,900' },
};

export const adminGetOnsiteSurcharges = async () => {
  await delay(200);
  return onsiteSurcharges;
};

/** GET /api/admin/price/regional/golf — 골프 지역별 요금 (어드민 편집용) */
const adminGolfRegionalEditable = {
  seoul: { label: '서울', price: '139,000' },
  gyeonggi: { label: '경기도', price: '109,000' },
  incheon: { label: '인천', price: '109,000' },
};

export const adminGetGolfRegionalPricing = async () => {
  await delay(200);
  return adminGolfRegionalEditable;
};

/** GET /api/admin/price/regional/hospital — 병원 지역별 요금 (어드민 편집용) */
const adminHospitalRegionalEditable = {
  seoul: { label: '서울', price: '139,000' },
  bundang: { label: '분당', price: '109,000' },
};

export const adminGetHospitalRegionalPricing = async () => {
  await delay(200);
  return adminHospitalRegionalEditable;
};

/** PUT /api/admin/price/hospital-regional/:regionId */
export const adminUpdateHospitalRegionalPricing = async (regionId, data) => {
  await delay(300);
  return { id: regionId, ...data };
};

/** PUT /api/admin/price/options/:optionId */
export const updateAdminOption = async (optionId, data) => {
  await delay(400);
  const idx = options.findIndex((o) => o.id === Number(optionId));
  if (idx === -1) throw new Error('옵션을 찾을 수 없습니다');
  options[idx] = { ...options[idx], ...data };
  // max_qty 변경 시 모든 서비스의 동일 code 옵션에 max 값 전파 (BE는 자체 처리하지만 dummy는 FE에서 수동 동기화)
  if (typeof data.max_qty === 'number') {
    const targetCode = options[idx].code;
    Object.keys(serviceOptions).forEach((svc) => {
      serviceOptions[svc].forEach((o) => {
        const matches = o.id === targetCode || o.code === targetCode
          || (targetCode === 'child_seat' && o.id === 'carseat')
          || (targetCode === 'wheelchair' && o.id === 'wheelchair');
        if (matches) o.max = data.max_qty > 0 ? data.max_qty : undefined;
      });
    });
  }
  return options[idx];
};

/** GET /api/admin/price/pet — 반려동물 가격 조회 */
export const getAdminPetPricing = async () => {
  await delay(200);
  return {};
};

/** PUT /api/admin/price/pet — 반려동물 가격 수정 */
export const updateAdminPetPricing = async (data) => {
  await delay(300);
  return data;
};

/** GET /api/admin/price/business — 비즈니스 가격 조회 */
export const getAdminBusinessPricing = async () => {
  await delay(200);
  return {};
};

/** PUT /api/admin/price/business — 비즈니스 가격 수정 */
export const updateAdminBusinessPricing = async (data) => {
  await delay(300);
  return data;
};

/** GET /api/admin/price/ski — 스키 가격 목록 조회 */
export const getAdminSkiPricing = async () => {
  await delay(200);
  return [];
};

/** PUT /api/admin/price/ski/:skiId — 스키 가격 수정 */
export const updateAdminSkiPricing = async (skiId, data) => {
  await delay(300);
  return data;
};
